export class GenerationRateLimitError extends Error {
	public constructor(public cause?: unknown) {
		super('Generation rate limit exceeded');
		this.name = 'GenerationRateLimitError';
	}
}
